class RegionFilterVanilla {
    constructor(container) {
        this.container = container;
        this.targetSelector = container.dataset.attributeTarget;
        this.buttons = container.querySelectorAll('.projects__region');
        this.activeClass = 'projects__region--active';
        this.hiddenClass = 'projects__item--hidden';

        this.init();
    }

    init() {
        this.buttons.forEach(button => {
            button.addEventListener('click', () => this.selectRegion(button));
        });
    }

    selectRegion(button) {
        const region = button.dataset.region;

        this.buttons.forEach(btn => btn.classList.remove(this.activeClass));
        button.classList.add(this.activeClass);

        this.filterItems(region);
    }

    filterItems(region) {
        const items = document.querySelectorAll(this.targetSelector);

        items.forEach(item => {
            const matches = region === 'todo' || item.dataset.region === region;
            item.classList.toggle(this.hiddenClass, !matches);
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-js="region-filter"]').forEach(container => {
        new RegionFilterVanilla(container);
    });
});
